import React from 'react'
import { icon } from '../../../services/icon'

const UpdateButton = ({ updateFunction, value }) => {
    return (
        <button onClick={(e) => updateFunction(e, value)} className="baseocom-update-btn ">
            <span className="baseocom-hidden md:baseocom-block">Modifier</span>
            {icon('back')}
        </button>
    )
}

export default UpdateButton
